import Vue from "vue";
import { http } from "../config/http";

export default function useTravaInventario() {
  let intervaloMonitoramento = null;

  const estadoInventario = Vue.observable({
      inventarioTravado: true, 
      msgModalInventario: "",
      primeiraVerificacao: true 
  });

  async function verificarStatusInventario() {
      try {
          const resposta = await consultarAPIInventario();
          estadoInventario.inventarioTravado = resposta;

          if (!resposta  && !estadoInventario.primeiraVerificacao) {
            estadoInventario.msgModalInventario = "Inventário finalizado com sucesso. Por favor, atualize seu browser usando Ctrl + F5.";
          }

          if (!resposta) {
              interromperMonitoramento();
          }
          estadoInventario.primeiraVerificacao = false;

      } catch (error) {
          console.error("❌ Erro ao consultar API do inventário:", error);
      }
  }

  function iniciarMonitoramentoInventario() {
      if (!intervaloMonitoramento) {
          verificarStatusInventario(); // Primeira verificação imediata
          intervaloMonitoramento = setInterval(verificarStatusInventario, 5000);
      }
  }

  function interromperMonitoramento() {
      if (intervaloMonitoramento) {
          clearInterval(intervaloMonitoramento);
          intervaloMonitoramento = null;
      }
  }

  async function consultarAPIInventario() {
    try {
      const response = await http().get("/acordo/importacaoAndamento");
      return response.data.inventarioUltimoHistorico.importacaoAndamento;
    } catch (error) {
      console.error("❌ Erro ao consultar API do inventário:", error);
      return
    }
  }

  return { estadoInventario, iniciarMonitoramentoInventario, interromperMonitoramento };
}
